import type StandardChart from '../../core/StandardChart';
import { type Option } from '../../core/option';
import { handleFormatter, handleTooltip, handleLinks, handleNodeLengthPercent } from '../sankey';

type customObject = Record<string, any>;
type DataIndex = number;

interface DataItem {
  data: Array<Array<customObject>>;
  link: Array<Array<customObject>>;
  info: Array<customObject>;
  handleLinksStatus: Boolean;
  handleFormatterStatus: Boolean;
  handleTooltipStatus: Boolean;
  handleNodeLengthPercentStatus: Boolean;
}

export class DynamicSankeyHelper {
  private _chart: StandardChart;
  private _data: DataItem;
  private _option: Option;
  private _index: DataIndex;
  private _labelTextConfig: customObject;
  private _handleLinksStatus: Boolean;
  private _handleFormatterStatus: Boolean;
  private _handleTooltipStatus: Boolean;
  private _handleNodeLengthPercentStatus: Boolean;
  constructor(chart: StandardChart, option: Option, data: DataItem) {
    this._chart = chart;
    this._data = data;
    this._handleLinksStatus = this._data?.handleLinksStatus === false ? false : true;
    this._handleFormatterStatus = this._data?.handleFormatterStatus === false ? false : true;
    this._handleTooltipStatus = this._data?.handleTooltipStatus === false ? false : true;
    this._handleNodeLengthPercentStatus =
      this._data?.handleNodeLengthPercentStatus === false ? false : true;
    this._option = option;
    this._index = data.data.length - 1;
    this._labelTextConfig = { param1: 'num', param2: 'unit', param3: 'compare' };
  }

  private init() {
    const _this = this;
    if (this._handleLinksStatus === true) {
      const links = handleLinks(_this._data.data[_this._index], _this._data.link[_this._index]);
      _this._option.series[0].links = links;
    }
    if (this._handleFormatterStatus === true) {
      const data = _this._data.data[_this._index].map(item => {
        return Object.assign(
          {},
          item,
          handleFormatter(
            {
              width: _this._chart.getDom().offsetWidth,
              name: _this._data.info[_this._index].name,
              text: _this._data.info[_this._index].text
            },
            item,
            _this._labelTextConfig
          )
        );
      });
      _this._option.series[0].data = data;
    }
    if (this._handleTooltipStatus === true) {
      const tooltip = handleTooltip(_this._option.series[0]);
      _this._option.series[0].tooltip.formatter = tooltip;
    }
    if (this._handleNodeLengthPercentStatus === true) {
      const nodeLengthPercentArray = handleNodeLengthPercent(_this._data.data, {
        min: 0.33,
        max: 0.66,
        type: 'linear'
      });
      _this._option.series[0].dvNodeLengthPercent = nodeLengthPercentArray[_this._index];
    }
  }
  play(index?: number, config?: customObject, opts?: any) {
    this._index = index === 0 || index ? index : this._index;
    this._labelTextConfig = config?.labelTextConfig || this._labelTextConfig;
    this.init();
    const option = this._option;
    this._chart.play({
      option,
      opts: opts || {}
    });
  }
}
